// TODO: RESOLVE THIS PATH
// import { getFromAndToDate } from "containers/app/DashboardModule/charts/calendar/DoneActivitiesByResponsibleLineChart/helpers";
import moment from "moment";
import { DASHBOARD_RANGE_TYPES_DICTIONARY } from "../../../utils/constants/dashboard/dashboardModuleConstants";

export const getFromAndToDate = (
  dateRange:
    | { fromDate: moment.Moment; toDate: moment.Moment }
    | keyof typeof DASHBOARD_RANGE_TYPES_DICTIONARY,
  formatTemplate = "YYYY-MM-DD"
) => {
  if (typeof dateRange !== "string")
    return {
      fromDate: dateRange.fromDate.format(formatTemplate),
      toDate: dateRange.toDate.format(formatTemplate),
    };
  return DASHBOARD_RANGE_TYPES_DICTIONARY[dateRange].range;
};

export const INITIAL_STATE = {
  dateRange: {
    fromDate: moment().subtract(7, "days"),
    toDate: moment(),
  },
  error: undefined as string | undefined,
  isFocused: {
    fromDate: false,
    toDate: false,
  },
};

const DATE_RANGE_VALIDATION_ERRORS = {
  TOO_LONG: "O limite de pesquisa é 1 ano.",
  NO_FORESIGHT: "A data 'Até' não pode ser maior que hoje.",
  INVERSE_ORDER: "A data 'De' não pode ser maior ou igual que a data 'Até'.",
};

export const getTargetInput = (whichInput: string) =>
  whichInput === "FROM" ? "fromDate" : "toDate";

/**
 * Takes 2 moment dates and gives back this filter's
 * validation error messages. When message is undefined,
 * range is valid.
 * @param {{fromDate: MomentDate, toDate: MomentDate
 * }} dateRange
 * @returns {undefined | string}
 */
export const validateDateRange = (dateRange: {
  fromDate: moment.Moment;
  toDate: moment.Moment;
}) => {
  const { toDate, fromDate } = dateRange;
  if (toDate > moment()) return DATE_RANGE_VALIDATION_ERRORS.NO_FORESIGHT;
  if (fromDate > toDate) return DATE_RANGE_VALIDATION_ERRORS.INVERSE_ORDER;
  if (fromDate < moment().subtract(1, "year")) return DATE_RANGE_VALIDATION_ERRORS.TOO_LONG;

  return undefined;
};

export const getRangeLabel = (
  dateRange:
    | { fromDate: moment.Moment; toDate: moment.Moment }
    | keyof typeof DASHBOARD_RANGE_TYPES_DICTIONARY
) => {
  if (typeof dateRange !== "string") {
    const parsedDateRange = getFromAndToDate(dateRange, "DD/MM/YYYY");
    return `${parsedDateRange.fromDate} à ${parsedDateRange.toDate}`;
  }
  return DASHBOARD_RANGE_TYPES_DICTIONARY[dateRange].label;
};
